import { AccordionItem } from '@jouzen/ecom-components/v4/Accordion';
import { useTranslations } from 'next-intl';

import TwoColumnAccordionSection from '@/app/components/TwoColumnAccordionSection';

import data from '../_data/activityAndMovementTrackingData';

const accordionItemClassName = 'bg-sandstone-400 text-brown-600';

const ActivityAndMovementTracking = () => {
  const t = useTranslations();
  return (
    <TwoColumnAccordionSection
      dataCy="activity-and-movement-tracking"
      imageColStart="main"
      imageAltKey="activity_tracking_img_alt"
      imageSrcSet={[
        {
          media: '(max-width: 1023px)',
          src: 'activity-and-movement/activity-tracking.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.44&fp-z=1',
        },
        {
          media: '(min-width: 1024px)',
          src: 'activity-and-movement/activity-tracking.jpg?ar=5:6&fit=crop&crop=focalpoint&fp-x=0.45&fp-y=0.42&fp-z=1.05',
        },
      ]}
      title="activity_tracking_title"
      copy="activity_tracking_copy"
      titleClassName="text-brown-600"
      copyClassName="text-brown-600"
    >
      {data.map(({ Icon, ...highlight }) => (
        <AccordionItem
          key={highlight.id}
          className={accordionItemClassName}
          header={t(highlight.header)}
          icon={<Icon className="w-6" />}
        >
          {t(highlight.content)}
        </AccordionItem>
      ))}
    </TwoColumnAccordionSection>
  );
};

export default ActivityAndMovementTracking;
